'use client'

import { cn } from '@mntn-dev/ui-utilities'
import { Icon, type IconProps } from '../../../icon/icon.tsx'
import { iconGlowMap } from '../../../icon/index.ts'

export type ModalCenteredHeaderIconProps = Partial<
  Pick<IconProps, 'color' | 'fill' | 'size'>
> & {
  name: IconProps['name']
  className?: string
}

export const ModalCenteredHeaderIcon = ({
  className,
  color = 'info',
  fill = 'solid',
  size = '4xl',
  name,
}: ModalCenteredHeaderIconProps) => {
  return (
    <Icon
      name={name}
      color={color}
      fill={fill}
      size={size}
      className={cn(iconGlowMap[color], className)}
    />
  )
}
